import styled, { css } from 'styled-components'
import { SelectDropdownModalHeader } from '@sketch/components'
export {
  BackButton,
  BackIcon,
} from 'modules/shares/ComponentsWebView/components/Sidebar/MobileGroupsDropdown.styles'
export {
  SelectDropdownModalFooter,
  SelectDropdownCancelButton,
} from '@sketch/components'

export const MobileNavigationHeader = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.D};
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes.B};
    text-transform: uppercase;
    margin-left: 8px;
    margin-top: 12px;
  `
)

export const TallerModalHeader = styled(SelectDropdownModalHeader)`
  padding: 10px 0; /* stylelint-disable-line scales/space */
`
